import i18next from 'i18next';
import { useTranslation } from 'i18next-vue';

import { AppLocale } from '@shared/i18n';
import passengerCounterRU from './ru.json';
import passengerCounterKK from './kk.json';

const NAMESPACE_NAME = 'passengers-counter';

export function usePassengerCounterLocales() {
  if (i18next.language === AppLocale.RU) {
    i18next.addResourceBundle(
      AppLocale.RU,
      NAMESPACE_NAME,
      passengerCounterRU,
      true,
    );
  } else {
    i18next.addResourceBundle(
      AppLocale.KK,
      NAMESPACE_NAME,
      passengerCounterKK,
      true,
    );
  }

  return useTranslation(NAMESPACE_NAME);
}
